import { Input, Modal, Textarea } from '@salecycle/ui-component-library';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from 'sections/client-management/ui/pages/client-settings/supported-languages/constants/SupportedLanguagesConstants';
import { useTemplatesListState } from '../context/UseTemplatesListContext';
import { useFeatureFlags } from 'core/app/AppContext';

export const SubjectLineModal = ({ showModal, subjectLine, onCloseButtonClicked, onOkButtonClicked }) => {
  const { t } = useTranslation(['supportedLanguages', 'designs']);
  const [subjectLines, setSubjectLines] = useState({});
  const [subjectLinesComment, setSubjectLinesComment] = useState<string>();
  const { supportedLanguages } = useTemplatesListState();
  const { flagEnabled } = useFeatureFlags();

  useEffect(() => {
    const getInitialSubjectLines = () => {
      const subjectLines = {};
      supportedLanguages.forEach((id: string) => {
        if (subjectLine && subjectLine.subjectLines[id.toUpperCase()]) {
          subjectLines[id] = subjectLine.subjectLines[id.toUpperCase()];
        } else {
          subjectLines[id] = '';
        }
      });
      return subjectLines;
    };

    setSubjectLines(getInitialSubjectLines());
  }, [subjectLine, supportedLanguages]);

  const heading =
    subjectLine === null
      ? t('designs:designGallery.subjectLines.addSubjectLines')
      : t('designs:designGallery.subjectLines.editSubjectLines');

  const isEdit = subjectLine !== null;

  if (!showModal) {
    return null;
  }

  const getNonEmptySubjectLines = () => {
    const output = {};
    Object.entries(subjectLines).forEach(([k, v]) => {
      if (v) {
        output[k] = v;
      }
    });
    return output;
  };

  const handleOkClick = () => {
    setSubjectLines({});
    onOkButtonClicked(
      {
        enabled: true,
        ...subjectLine,
        subjectLines: getNonEmptySubjectLines(),
        audit: { comment: subjectLinesComment },
      },
      isEdit,
    );
  };

  const isOkDisabled =
    false ||
    Object.values(subjectLines).filter(s => s).length === 0 ||
    (flagEnabled('ld-subject-lines-audit') &&
      (subjectLinesComment === undefined || subjectLinesComment === null || subjectLinesComment?.length === 0));

  const handleSubjectLinesCommentChanged = (comment: string) => {
    setSubjectLinesComment(comment);
  };

  return (
    <Modal
      isOpen={true}
      heading={heading}
      variation="clean"
      size="tall"
      onCloseButtonClicked={onCloseButtonClicked}
      onCancelButtonClicked={onCloseButtonClicked}
      onOkButtonClicked={handleOkClick}
      okButtonLabel={t('designs:designGallery.subjectLines.saveButton')}
      maxHeight={true}
      okButtonDisabled={isOkDisabled}
    >
      {supportedLanguages.map(id => {
        const { name } = SUPPORTED_LANGUAGES.find(s => s.id === id);
        const v = subjectLines[id];
        return (
          <Input
            key={id}
            ariaLabel={t(name)}
            label={t(name)}
            value={v}
            onChange={value => setSubjectLines({ ...subjectLines, [id]: value })}
          />
        );
      })}
      {flagEnabled('ld-subject-lines-audit') && (
        <Textarea
          label={t('designs:designGallery.subjectLines.comment')}
          ariaLabel="subject-lines-comment"
          onChange={handleSubjectLinesCommentChanged}
          placeholder="Enter a reason for this update"
          value={subjectLinesComment}
        />
      )}
    </Modal>
  );
};
